export default __webpack_public_path__ + "static/media/icon-telephone.2bd88f04.svg";